import type {
  PartnerCarrierSettings,
  PartnerCarrierSettingsCreate,
  PartnerCarrierSettingsUpdate,
  PartnerSearchCarrierSettingsParams,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const carrierSettings = {
  search: {
    queryKey: 'partner-management-service/carrier-settings',
    configurationType: 'default' as const,
    fn: async (params: PartnerSearchCarrierSettingsParams = {}) => {
      const { data } = await GatewayAxiosClient.get<PartnerCarrierSettings[]>(
        `/partner-management-proxy/api/v1/partners/carrierSettings`,
        {
          params,
        },
      );

      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/carrier-settings/id',
    configurationType: 'no-cache' as const,
    fn: async (carrierSettingId: string): Promise<PartnerCarrierSettings> => {
      const { data } = await GatewayAxiosClient.get<PartnerCarrierSettings>(
        `/partner-management-proxy/api/v1/partners/carrierSettings/${carrierSettingId}`,
      );

      return data;
    },
  },
  create: async (payload: PartnerCarrierSettingsCreate) => {
    const { data } = await GatewayAxiosClient.post<PartnerCarrierSettings>(
      `/partner-management-proxy/api/v1/partners/carrierSettings`,
      payload,
    );

    return { data, invalidateQueryKeys: [['partner-management-service/carrier-settings']] };
  },
  update: async ({
    carrierSettingsId,
    payload,
  }: {
    carrierSettingsId: string;
    payload: PartnerCarrierSettingsUpdate;
  }) => {
    const { data } = await GatewayAxiosClient.put<PartnerCarrierSettings>(
      `/partner-management-proxy/api/v1/partners/carrierSettings/${carrierSettingsId}`,
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [
        ['partner-management-service/carrier-settings'],
        ['partner-management-service/carrier-settings/id', carrierSettingsId],
      ],
    };
  },
};
